﻿// import { onEvent } from "./_dom";

function createValidator(typeOrExt) {
	typeOrExt = typeOrExt.toLowerCase();
	if (typeOrExt.indexOf("/") > 0) {
		if (typeOrExt.endsWith("/*")) {
			typeOrExt = typeOrExt.slice(0, -1);
			return file => file.type.toLowerCase().startsWith(typeOrExt);
		}
		return file => file.type.toLowerCase() === typeOrExt;
	} else if (typeOrExt[0] === ".") {
		return file => file.name.toLowerCase().endsWith(typeOrExt);
	} else {
		return () => false;
	}
}

function checkFileTypes(input) {
	const files = input.files;
	if (input.accept && files && files.length > 0) {
		const acceptedTypes = input.accept.split(/\s*,\s*/g);
		if (acceptedTypes.indexOf("*") < 0) {
			const validators = acceptedTypes.map(createValidator);
			if (files) {
				for (let i = 0; i < files.length; i++) {
					var file = files[i];
					if (!validators.some(v => v(file))) {
						return file;
					}
				}
			}
		}
	}
}

function handleCheckFileTypes(event) {
	const input = event.target;
	const invalidFile = checkFileTypes(input);
	if (invalidFile) {
		event.stopPropagation();
		event.preventDefault();
		alert(input.dataset.message || input.title || "Selected file is not valid: " + invalidFile.name);
		input.value = "";
		input.dispatchEvent(new Event("change", { bubbles: true }));
	}
}

/*
function init(context) {
	onEvent(context, "input[type=file][accept]", "change", handleCheckFileTypes);
}
*/
export { /* init, */checkFileTypes, handleCheckFileTypes };